import { ImmutableArray } from "@hookstate/core"
import { LinearProgress, Stack, Typography } from "@mui/material"
import { FC } from "react"

import { Table, TableData } from "src/components/common/table"
import { create } from "src/helpers/bem"
import { useTranslation } from "src/hooks/translation"
import { mergeDialog } from "src/states/dialogs"
import { useIncidents } from "src/states/incident"
import { TranslationMessages } from "src/translations"
import { xRMApiIncident } from "src/types/xRM"

import styles from "./IncidentsTable.module.scss"

const bem = create(styles, "IncidentsTable")

export type IncidentsTableProps = {
  messages: TranslationMessages
}

export const IncidentsTable: FC<IncidentsTableProps> = ({ messages }) => {
  const { incidents, loading } = useIncidents()
  const { messages: translations } = useTranslation()
  const m = translations.pages.account.overview.profile.incidents

  const renderTable = (data: TableData[]) => (
    <>
      {data.length > 0 ? (
        <div className={bem("table")}>
          <Table
            cellTranslations={m.table}
            data={data}
            messages={messages}
            order="desc"
            orderBy="date"
            handleClickCell={(_e, _name, id) =>
              mergeDialog("incidentDialog", {
                open: true,
                disabled: true,
                incidentId: id,
              })
            }
          />
        </div>
      ) : (
        <p className={bem("nodata")}>{m.noData}</p>
      )}
    </>
  )

  const formatIncidents = (
    items: ImmutableArray<xRMApiIncident>,
  ): TableData[] =>
    items.map((incident) => ({
      name: incident.ticketNumber ?? "--",
      id: incident.id ?? "--",
      type: incident.incidentType,
      status: incident.statecode,
    }))

  if (loading) return <LinearProgress color="primary" />

  return (
    <Stack className={bem("card")} direction={"column"}>
      <div className={bem("card", "header")}>
        <Typography variant="subtitle1">{m.title}</Typography>
      </div>
      <Stack
        className={bem("card", "content")}
        direction={"row"}
        justifyContent={"space-between"}
      >
        {renderTable(formatIncidents(incidents))}
      </Stack>
    </Stack>
  )
}
